import { render, staticRenderFns } from "./ElectoralRoll.vue?vue&type=template&id=f21e15ba"
import script from "./ElectoralRoll.vue?vue&type=script&lang=js"
export * from "./ElectoralRoll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports